/**
 * Roles & access — Day 1 (role-level only; per-entity scoping is Module 2).
 * See PLAN.md §4.
 */
export const ROLES = [
    'admin',
    'inside_accountant',
    'outside_accountant',
    'lawyer',
    'family_member',
    'admin_assistant',
    'other',
];
export const CATEGORIES = [
    'entity_formation',
    'tax',
    'regulatory',
    'fund_accounting',
    'fund_admin',
    'banking',
    'governance',
    'investments',
    'legal_contracts',
    'legal_personal',
    'insurance',
    'real_estate',
    'personal_assets',
    'correspondence',
    'bill_pay',
    'other',
];
/**
 * Default category visibility per role. Admin sees everything.
 * Stored as `allowedCategories` on the user's Firebase Auth custom claims so
 * Firestore rules can check inclusion without a doc lookup.
 *
 * `other` role has no defaults — admin grants per-doc.
 */
export const ROLE_DEFAULT_CATEGORIES = {
    admin: CATEGORIES,
    inside_accountant: CATEGORIES.filter((c) => c !== 'legal_personal' && c !== 'personal_assets'),
    outside_accountant: [
        'tax',
        'fund_accounting',
        'regulatory',
        'banking',
        'entity_formation',
    ],
    lawyer: [
        'legal_contracts',
        'legal_personal',
        'entity_formation',
        'governance',
        'regulatory',
    ],
    family_member: ['legal_personal', 'tax', 'personal_assets'],
    admin_assistant: [
        'correspondence',
        'governance',
        'insurance',
        'bill_pay',
    ],
    other: [],
};
export function categoriesFor(role) {
    return ROLE_DEFAULT_CATEGORIES[role];
}
export function canSeeCategory(role, category) {
    if (role === 'admin')
        return true;
    return ROLE_DEFAULT_CATEGORIES[role].includes(category);
}
//# sourceMappingURL=roles.js.map